interface Question {
  name: string;
  parentSubcategories: string[];
  fieldType: string;
  response: string;
}

export const clearSelectInputField = (selectedQuestions: Question[]) => {
  const els = document.querySelectorAll(".css-1dimb5e-singleValue")!;
  els.forEach((el) => {
    if (
      el.textContent!.toLowerCase() ===
      selectedQuestions[0].response.toLowerCase()
    ) {
      el.textContent = "";
    }
  });
};
